import * as React from 'react';

import { Checkbox } from '@components/checkbox';

interface DocumentsDropdownPropsType {
    id: string | string[];
    checkFn: any;
    documentsChecked: any;
    documentLabels: any[];
    isVisible: boolean;
}

const DocumentsDropdown: React.FC<DocumentsDropdownPropsType> = ( props: DocumentsDropdownPropsType, {} ) => {
    return (
        <div
            className={ `absolute z-400 w-[calc(100%+8px)] overflow-hidden border border-[#eceff1] bg-white px-2 transition-all duration-500 ease-in-out ${ props.isVisible ? 'max-h-[375px] py-[5px] shadow-[0_8px_0_rgba(0,0,0,0.1)]' : 'max-h-0 border-0 py-0 shadow-none' }` }
        >
            { props.documentLabels.map( ( label ) => (
                <Checkbox
                    key={ `docLabel_${ label.key } ` }
                    checked={ Number( props.documentsChecked[ label.key ] ) === 1 }
                    indeterminate={ Number( props.documentsChecked[ label.key ] ) === 2 }
                    updateCallback={ ( newVal ) => props.checkFn(
                        typeof props.id === 'string' ? [ props.id ] : props.id,
                        [ label.key ],
                        newVal ) }
                    label={ label.label }
                />
            ) ) }
        </div>
    );
};

export { DocumentsDropdown as default };
